// extracted by mini-css-extract-plugin
export default {"profileCard":"UserProfile_profileCard__80Z8G","profileImg":"UserProfile_profileImg__Ds4It","skillItem":"UserProfile_skillItem__rIULn"};